import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import axios from '../../util/Axios';
import { useState } from 'react';

export function UploadEvaluation({ dataSetId, handleClose, open }) {
  const [file, setFile] = useState(null);

  const handleFileUpload = (e) => {
    if (!e.target.files) {
      return;
    }

    setFile(e.target.files[0]);
  };

  function uploadEvaluation() {
    const formData = new FormData();
    formData.append('file', file);

    axios(`dataSets/${dataSetId}/evaluation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
    }).then((resp) => handleClose(true));
  }

  return (
    <>
      <Dialog open={open}>
        <DialogTitle>Upload Evaluation</DialogTitle>
        <DialogContent>
          <input type="file" onChange={handleFileUpload} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" onClick={uploadEvaluation}>
            Upload
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
